import { Table, Column, Cell } from "fixed-data-table-2";
import moment from "moment";
import PropTypes from "prop-types";
import {
  LinearProgress,
  CircularProgress,
  Typography
} from "@material-ui/core";
import React from "react";
import RowActionMenuPopover from "./RowActionMenuPopover";

class FormStatusTable extends React.Component {
  constructor(props) {
    super(props);
    this.onColumnResizeEndCallback = this.onColumnResizeEndCallback.bind(this);

    this.state = {
      columnWidths: {
        date_submitted: 125,
        submission_id: 100,
        index: 90,
        source: 110,
        submission_device: 125,
        formName: 260,
        status: 135,
        actions: 55
      }
    };
  }

  onColumnResizeEndCallback(newColumnWidth, columnKey) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth
      }
    }));
  }

  render() {
    const styles = {
      statusBadge: {
        fontSize: "12px",
        display: "inline-block",
        fontWeight: "bold",
        color: "white",
        padding: "5px",
        minWidth: "20px",
        borderRadius: "10px",
        verticalAlign: "top",
        marginRight: "3px",
        marginTop: "8px"
      },
      tableFont: {
        fontFamily: "Roboto",
        fontSize: "14px"
      }
    };

    const { columnWidths } = this.state;
    if (this.props.isFetching)
      return <LinearProgress style={{ width: "100%" }} />;
    if (!this.props.formDataFiltered.length)
      return (
        <Typography>
          <h3>No Submission Data found</h3>
        </Typography>
      );

    const rows = this.props.formDataFiltered;

    return (
      <div>
        <Typography>
          {this.props.formData.length && (
            <span>
              <b>{this.props.formDataFiltered.length}</b> records found.
            </span>
          )}
          {this.props.formData.length !==
            this.props.formDataFiltered.length && (
            <span>
              {" "}
              Filtering on rows containing {`"${this.props.searchFilter}"`}
            </span>
          )}
        </Typography>
        <div style={styles.tableFont}>
          <Table
            rowHeight={75}
            rowsCount={rows.length}
            width={this.props.width}
            headerHeight={50}
            height={window.innerHeight - 100}
            onColumnResizeEndCallback={this.onColumnResizeEndCallback}
            isColumnResizing={false}
          >
            <Column
              columnKey="status"
              header={<Cell> Status </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>
                  {this.props.rowsUpdating.includes(
                    rows[rowIndex].submission_id
                  ) && (
                    <CircularProgress
                      size={35}
                      thickness={5}
                      style={{ marginRight: "3px" }}
                    />
                  )}
                  {!rows[rowIndex].count_error &&
                    !rows[rowIndex].count_warning &&
                    rows[rowIndex].is_valid && (
                      <span
                        style={{
                          ...styles.statusBadge,
                          backgroundColor: "#53c77c"
                        }}
                      >
                        OK
                      </span>
                    )}
                  {!rows[rowIndex].is_valid && (
                    <span
                      style={{
                        ...styles.statusBadge,

                        backgroundColor: "rgb(182, 12, 15)"
                      }}
                    >
                      Blocked
                    </span>
                  )}
                  {rows[rowIndex].was_recalled && (
                    <span
                      style={{
                        ...styles.statusBadge,
                        backgroundColor: "red"
                      }}
                    >
                      recalled
                    </span>
                  )}
                  {!rows[rowIndex].process_form && (
                    <span
                      style={{
                        ...styles.statusBadge,

                        backgroundColor: "#5bc0de"
                      }}
                    >
                      deleted
                    </span>
                  )}

                  {rows[rowIndex].count_error && (
                    <span
                      style={{
                        ...styles.statusBadge,

                        backgroundColor: "rgb(182, 12, 15)"
                      }}
                    >
                      {rows[rowIndex].count_error} Error
                      {rows[rowIndex].count_error > 1 ? "s" : ""}
                    </span>
                  )}

                  {rows[rowIndex].count_warning && (
                    <span
                      style={{
                        ...styles.statusBadge,

                        backgroundColor: "rgb(255, 171, 0)"
                      }}
                    >
                      {rows[rowIndex].count_warning} Warning
                      {rows[rowIndex].count_warning > 1 ? "s" : ""}
                    </span>
                  )}
                </Cell>
              )}
              width={columnWidths.status}
              isResizable
            />

            <Column
              columnKey="date_submitted"
              header={<Cell> Submitted </Cell>}
              cell={({ ...colProps }) => (
                <Cell {...colProps}>
                  {moment(rows[colProps.rowIndex].submitted_dt).format(
                    "YYYY-MM-DD H:mm"
                  )}
                </Cell>
              )}
              width={columnWidths.date_submitted}
              isResizable
              // flexGrow={1}
            />

            <Column
              columnKey="submission_id"
              header={<Cell> Submission ID </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].submission_id}</Cell>
              )}
              width={columnWidths.submission_id}
              isResizable
              flexGrow={1}
            />

            <Column
              columnKey="source"
              header={<Cell> Source </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>
                  {rows[rowIndex].submission_source.replace("@hakai.org", "")}
                </Cell>
              )}
              width={columnWidths.source}
              isResizable
            />

            <Column
              columnKey="submission_device"
              header={<Cell> Device </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].submission_device}</Cell>
              )}
              width={columnWidths.submission_device}
              isResizable
              flexGrow={1}
            />

            <Column
              columnKey="formName"
              header={<Cell> Form Name </Cell>}
              cell={({ rowIndex, ...colProps }) => (
                <Cell {...colProps}>{rows[rowIndex].form_name}</Cell>
              )}
              width={columnWidths.formName}
              isResizable
              flexGrow={1}
            />
            <Column
              columnKey="actions"
              header={<Cell />}
              cell={({ rowIndex }) => (
                <Cell style={{ marginTop: "5px" }}>
                  <RowActionMenuPopover {...this.props} rowIndex={rowIndex} />
                </Cell>
              )}
              width={columnWidths.actions}
            />
          </Table>
        </div>
      </div>
    );
  }
}

FormStatusTable.propTypes = {
  rowsUpdating: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchFilter: PropTypes.string.isRequired,
  onStatusRowClick: PropTypes.func.isRequired,
  width: PropTypes.number,
  formData: PropTypes.arrayOf(PropTypes.object),
  formDataFiltered: PropTypes.arrayOf(
    PropTypes.shape({
      warning_log: PropTypes.string,
      form_name: PropTypes.string,
      submission_device: PropTypes.string,
      error_log: PropTypes.string,
      submission_source: PropTypes.string,
      submission_id: PropTypes.string,
      process_form: PropTypes.bool,
      is_valid: PropTypes.bool,
      submitted_dt: PropTypes.string,
      count_warning: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      count_error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      was_recalled: PropTypes.bool
    })
  ).isRequired,
  isFetching: PropTypes.bool
};

FormStatusTable.defaultProps = {
  formData: [],
  isFetching: false,
  width: 0
};

FormStatusTable.shouldComponentUpdate = () => false;
export default FormStatusTable;
